<template lang="pug">
	section.section.main-section.download-app-container
		.section-content(v-if="loadingPromoCode || !accessToken")
			.hourglass-outer
				hourglass

		.section-content(v-else-if="subscriptionActive")
			.columns.is-centered.is-vcentered
				.column
					profile-active

		.section-content(v-else-if="subscriptionExpired")
			title-comp.margin-top-md(:name="$t('profile.expired_subscription')")
			.columns.is-centered.is-vcentered
				.column
					.split-container
						p.subtitle.has-text-centered.no-line-break-mobile
							| {{ $t('profile.expired_promo_code_help1') }}
					profile-promo-code(@onload="loadPromoCode", @onloaded="loadedPromoCode")

		.section-content.section-content-flex(v-else-if="userState && userState.voucher_active && !userState.subscription_canceled")
			.columns.is-centered.is-vcentered
				.column
					.split-container(style="padding-top: 0;")
						.form-container(style="width:100%; padding-top: 0; padding-bottom: 0;")
							template(v-if="errorPage")
								.columns.is-centered.is-vcentered.is-multiline.is-mobile
									.column.is-narrow
										.field
											p.control.has-text-centered
												button.button.is-primary(type="button" @click="loadUserState")
													| {{ $t('button.refresh') }}

								article.message.is-danger(transition="fade")
									.message-body
										| {{ $t('alert.generic_error') }}

							template(v-else)
								.subscription-box(v-if="subscriptionPayment && subscriptionPrice && (subscriptionPayment.has_trial || userState.has_trial)")
									p.intro-slot {{ $t('profile.subscription_promo') }}
									p.trial-slot(v-if="subscriptionPayment.special_trial")
										| {{ $t('profile.subscription_trial1', { 'date': getDate(subscriptionPayment.trial) }) + ' ' }}
										strong {{ $t('profile.subscription_trial_free') + ' ' }}
										| {{ $t('profile.subscription_trial2', { 'date': getDate(subscriptionPayment.trial) }) }}
									p.trial-slot(v-else)
										| {{ $t('profile.subscription_trial1_month') + ' ' }}
										strong {{ $t('profile.subscription_trial_free') + ' ' }}
										| {{ $t('profile.subscription_trial2_month') }}

									.price-slot(v-if="subscriptionPayment.special_trial && subscriptionPayment.discount")
										| {{ $t('profile.subscription_after_trial', { 'new': subscriptionPrice, 'amount': formattedPrice, 'perc': subscriptionPayment.discount }) }}
									.price-slot(v-else-if="subscriptionPayment.discount")
										| {{ $t('profile.subscription_after_trial_month', { 'new': subscriptionPrice, 'amount': formattedPrice, 'perc': subscriptionPayment.discount }) }}
								.subscription-box(v-else-if="subscriptionPayment && subscriptionPrice")
									p.intro-slot {{ $t('profile.subscription_promo') }}
									p.trial-slot
										| {{ $t('profile.subscription_notrial1', { 'date': getDate(subscriptionPayment.sub_end) }) }}
									.price-slot(v-if="subscriptionPayment.discount")
										| {{ $t('profile.subscription_notrial2', { 'new': subscriptionPrice, 'amount': formattedPrice, 'perc': subscriptionPayment.discount }) }}
									.price-slot(v-else)
										| {{ $t('profile.subscription_notrial_nocoupon', { 'amount': subscriptionPrice }) }}
								.subscription-box(v-else)
									p.intro-slot {{ $t('profile.subscription_promo') }}

								payment-help(:subscription-payment="subscriptionPayment" :has-trial="userState.has_trial")

								form#payment-form
									.field(v-if="subscriptionPayment")
										label.label(for="fullname") {{ $t('placeholder.payment_name') }}
										p.control
											input.input#fullname(
												type="text"
												name="fullname"
												maxlength="24"
												v-model="fullname")

									.field
										label.label(v-if="subscriptionPayment") {{ $t('placeholder.payment_card') }}
										#card-element

										.margin-top-xs
											#card-element-errors(role="alert")

										.margin-top-xs(v-if="subscriptionPayment")
											span(style="font-size:90%;") {{ $t('form.cvc_help') }}

									.field.margin-top-md(v-if="subscriptionPayment")
										label.checkbox
											input(type='checkbox' v-model="invoiceData")
											| {{ $t('form.enter_invoice_data') }}

									div(v-if="invoiceData")
										.field.margin-top-xs
											label.label {{ $t('placeholder.invoice_type') }}
											.control: .select(style="width:100%")
												select(v-model="invoiceType" style="width:100%")
													option(value="company") {{ $t('placeholder.invoice_type_company') }}
													option(value="personal") {{ $t('placeholder.invoice_type_personal') }}

										template(v-if="invoiceType")
											.field.margin-top-xs(v-if="invoiceType === 'company'")
												label.label {{ $t('placeholder.company_name') }}
												p.control: input.input(type="text" maxlength="40" v-model="companyName")

											.columns.is-centered.is-vcentered.is-multiline(style="padding-left:.5rem; padding-right:.5rem;")
												.column
													label.label {{ $t('placeholder.name') }}
													p.control: input.input(type="text" maxlength="30" v-model="invoiceName")
												.column
													label.label {{ $t('placeholder.surname') }}
													p.control: input.input(type="text" maxlength="30" v-model="invoiceSurname")

											.columns.is-centered.is-vcentered.is-multiline(style="padding-left:.5rem; padding-right:.5rem;" v-if="invoiceType === 'company'")
												.column
													label.label {{ $t('placeholder.taxcode') }}
													p.control: input.input(type="text" maxlength="18" v-model="invoiceTaxcode")
												.column
													label.label {{ $t('placeholder.vat') }}
													p.control: input.input(type="text" maxlength="13" v-model="companyVat")

											.field.margin-top-xs(v-else)
												label.label {{ $t('placeholder.taxcode') }}
												p.control: input.input(type="text" maxlength="18" v-model="invoiceTaxcode")

											.columns.is-centered.is-vcentered.is-multiline(style="padding-left:.5rem; padding-right:.5rem;")
												.column
													label.label {{ $t('placeholder.address') }}
													p.control: input.input(type="text" maxlength="48" v-model="companyAddress")
												.column.is-narrow
													label.label {{ $t('placeholder.postalCode') }}
													p.control: input.input(type="text" maxlength="6" v-model="companyPostalCode")
											
											.columns.is-centered.is-vcentered.is-multiline(style="padding-left:.5rem; padding-right:.5rem;")
												.column
													label.label {{ $t('placeholder.city') }}
													p.control: input.input(type="text" maxlength="48" v-model="companyCity")
												.column
													label.label {{ $t('placeholder.province') }}
													p.control: input.input(type="text" maxlength="48" v-model="companyProvince")

											.columns.is-centered.is-vcentered.is-multiline(style="padding-left:.5rem; padding-right:.5rem;" v-if="invoiceType === 'company'")
												.column
													label.label {{ $t('placeholder.pec') }}
													p.control: input.input(type="text" maxlength="48" v-model="companyPec")
												.column
													label.label {{ $t('placeholder.destinationCode') }}
													p.control: input.input(type="text" maxlength="48" v-model="companyDestCode")

									.has-text-centered.margin-top-md(v-if="subscriptionPayment")
										button.button.is-primary(type="button" @click="submitPayment" style="min-width:150px;")
											| {{ (subscriptionPayment.has_trial || userState.has_trial) ? $t('button.submit_trial') : $t('button.submit_pay') }}

									.has-text-centered.margin-top-sm(v-if="subscriptionPayment")
										img(src="/img/stripe_secure_payments.png" style="max-width:320px;")

									.loading-payment(v-if="loadingPayment")
										.hourglass-outer
											hourglass

		.section-content.section-content-flex(v-else)
			title-comp.margin-top-md(:name="$t('title.download_app')")
			.columns.is-centered.is-vcentered
				.column
					.split-container
						p.subtitle.has-text-centered.no-line-break-mobile
							| {{ $t('profile.promo_code_help1') }}
					profile-promo-code(@onload="loadPromoCode", @onloaded="loadedPromoCode")

</template>

<script>
import { setTimeout } from 'timers';
import TitleComponent from '../components/TitleComponent.vue'
import HourglassComponent from '../components/HourglassComponent.vue'
import ProfilePaymentHelp from '../components/ProfilePaymentHelp.vue'
import ProfileActive from '../components/ProfileActive.vue'
import ProfilePromoCode from '../components/ProfilePromoCode.vue'

import Config from '../config'

export default {
	components: {
		TitleComp       : TitleComponent,
		Hourglass       : HourglassComponent,
		PaymentHelp     : ProfilePaymentHelp,
		ProfileActive   : ProfileActive,
		ProfilePromoCode: ProfilePromoCode
	},
	data() {
		return {
			fullname         : '',
			emptyPage        : false,
			errorPage        : false,
			loadingPromoCode : false,
			loadingPayment   : false,
			lockedPrepare    : false,
			invoiceData      : false,
			invoiceType      : '',
			companyName      : '',
			companyAddress   : '',
			companyPostalCode: '',
			companyCity      : '',
			companyProvince  : '',
			companyVat       : '',
			invoiceTaxcode   : '',
			invoiceName      : '',
			invoiceSurname   : '',
			companyPec       : '',
			companyDestCode  : '',
			stripeScript     : null
		}
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		userState() {
			return this.$store.state.user.userState
		},
		subscriptionActive() {
			const userState = this.$store.state.user.userState
			return userState && (userState.trial_active || userState.subscription_active) && !userState.expired_subscription && !userState.subscription_canceled
		},
		subscriptionExpired() {
			const userState = this.$store.state.user.userState
			return userState && (userState.trial_active || userState.subscription_active) && userState.expired_subscription && !userState.subscription_canceled
		},
		subscriptionPayment() {
			return this.$store.state.user.userSubscriptionPayment
		},
		subscriptionPrice() {
			if (this.subscriptionPayment) {
				if (this.subscriptionPayment.discount) {
					return Number(this.subscriptionPayment.amount * (100 - this.subscriptionPayment.discount) / 100.0).toFixed(2).replace('.', ',')
				}
				
				return Number(this.subscriptionPayment.amount).toFixed(2).replace('.', ',')
			}

			return '0,00'
		},
		formattedPrice() {
			if (this.subscriptionPayment) {
				return Number(this.subscriptionPayment.amount).toFixed(2).replace('.', ',')
			}

			return '0,00'
		},
		stripeData: {
			get() {
				return {
					'customer'    : this.$store.state.user.userCustomerId,
					'subscription': this.$store.state.user.userSubscriptionId,
					'secret'      : this.$store.state.user.userSubscriptionSecret
				}
			}
		},
		userAuth() {
			return this.$store.state.user.userAuth
		},
		loading() {
			return this.$store.state.invitecode.loading
		}
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.profile") + ' | ' + this.$t("title.home") })
		if (!this.accessToken) {
			console.warn('No access token')
			this.loadingPromoCode = true
			this.$router.replace('/')
			return
		}

		this.stripeScript = document.getElementById('my-stripe-script')
		if (this.stripeScript === null) {
			this.loadingPromoCode = true
			this.stripeScript = document.createElement("script")
			const self = this;
			this.stripeScript.onload = () => {
				self.loadUserState()
			};
			this.stripeScript.onerror = () => {
				this.loadingPromoCode = false
				this.errorPage = true
			}
			this.stripeScript.id = 'my-stripe-script'
			this.stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
			document.body.appendChild(this.stripeScript)
		} else {
			this.loadUserState()
		}
	},
	methods: {
		loadUserState() {
			this.loadingPromoCode = true
			this.loadingPayment = false
			this.lockedPrepare = true
			return this.$store.dispatch('user/getUserState', this.accessToken)
				.then(res => {
					/*if (res && res.state && res.state.subscription_active) {
						this.handleCountdownEnd()
					}*/
					this.emptyPage = false
					this.errorPage = false
					this.lockedPrepare = false

					if (res && res.state && res.state.subscription_canceled) {
						this.loadingPromoCode = false
					} else if (res && res.state && (res.state.trial_active || res.state.subscription_active)) {
						this.loadingPromoCode = false
					} else if (res && res.state && res.state.voucher_active) {
						console.info('Voucher activated, need payment info')
						return this.loadUserCustomer()
					} else {
						this.loadingPromoCode = false
					}
				})
				.catch(err => {
					this.loadingPromoCode = false
					this.loadingPayment = false
					this.lockedPrepare = false

					if (err.response && err.response.status) {
						switch (err.response.status) {
							case 403:
								if (err.response.data && err.response.data.error_message === 'Access Token Expired') {
									this.$store.dispatch('auth/clearToken').then(() => {
										this.$router.replace('/login')
									})
									return
								}
								break
							case 404:
								this.emptyPage = true
								break
							case 500:
								this.errorPage = true
								break
							default:
								console.warn(err.response.status)
						}
					} else {
						console.warn(err)
					}
				})
		},
		loadUserCustomer() {
			this.loadingPromoCode = true
			this.loadingPayment = false
			this.lockedPrepare = true
			return this.$store.dispatch('user/getUserCustomer', this.accessToken)
				.then(res => {
					this.loadingPromoCode = false
					this.loadingPayment = false
					this.lockedPrepare = false

					this.emptyPage = false
					this.errorPage = false
					this.$nextTick(() => {
						this.prepareStripe()
					})
				})
				.catch(err => {
					this.loadingPromoCode = false
					this.loadingPayment = false
					this.lockedPrepare = false

					if (err.response && err.response.status) {
						switch (err.response.status) {
							case 404:
								this.emptyPage = true
								break
							case 500:
								this.errorPage = true
								break
							default:
								console.warn(err.response.status)
						}
					} else {
						console.warn(err)
					}

					this.$nextTick(() => {
						this.prepareNewLoadUser()
					})
				})
		},
		prepareNewLoadUser() {
			if (this.lockedPrepare) { return }
			this.lockedPrepare = true
			this.loadingPayment = false
			if (this.accessToken && this.userState) {
				this.loadingPromoCode = true
				this.emptyPage = false
				this.errorPage = false
				setTimeout(() => {
					this.loadUserCustomer()
				}, 1000)
			} else if (this.accessToken) {
				this.loadingPromoCode = true
				this.emptyPage = false
				this.errorPage = false
				setTimeout(() => {
					this.loadUserState()
				}, 1000)
			}
		},
		prepareStripe() {
			if (this.userState && this.userState.voucher_active) {
				if (this.userState.trial_active || this.userState.subscription_active) { return }
				this.Stripe = Stripe(Config.stripe, { 'locale': 'it' })
				let elements = this.Stripe.elements();

				this.cardElement = elements.create('card', {
					'classes': {
						'base': 'StripeElement input'
					},
					'style': {
						'base': {
							'fontSize': '16px'
						}
					}
				});
				this.cardElement.mount('#card-element');

				this.cardElement.on('change', (event) => {
					this.displayError(event)
				})
			}
		},
		displayError(event) {
			let displayError = document.getElementById('card-element-errors')
			if (event.error) {
				displayError.textContent = event.error.message
			} else {
				displayError.textContent = ''
			}
		},
		checkInvoiceData() {
			if (!this.invoiceType) {
				this.$alert(this.$t('alert.missing_invoice_data'), null, 'warning');
				return false
			}

			if (!this.companyName && this.invoiceType === 'company') {
				this.$alert(this.$t('alert.missing_company_name'), null, 'warning');
				return false
			}

			if (!this.invoiceName || !this.invoiceSurname) {
				this.$alert(this.$t('alert.missing_name_surname'), null, 'warning');
				return false
			}

			if (!this.companyAddress || !this.companyPostalCode) {
				this.$alert(this.$t('alert.missing_company_address'), null, 'warning');
				return false
			}

			if (!this.companyCity || !this.companyProvince) {
				this.$alert(this.$t('alert.missing_company_city'), null, 'warning');
				return false
			}

			if (!this.companyVat && !this.invoiceTaxcode) {
				if (this.invoiceType === 'company') {
					this.$alert(this.$t('alert.missing_company_vat'), null, 'warning');
				} else {
					this.$alert(this.$t('alert.missing_invoice_tax_code'), null, 'warning');
				}
				return false
			}

			if (!this.companyPec && !this.companyDestCode && this.invoiceType === 'company') {
				this.$alert(this.$t('alert.missing_company_pec'), null, 'warning');
				return false
			}

			return true
		},
		getBillingDetails() {
			const nameInput = document.getElementById('fullname')

			const data = {
				'name': String(nameInput.value).trim()
			}

			if (this.invoiceData) {
				data.name = this.invoiceType === 'company' ? (this.invoiceName + ' ' + this.invoiceSurname) : this.companyName
				data.address = {
					"city"       : this.companyCity,
					'country'    : 'IT',
					"line1"      : this.companyAddress,
					"line2"      : this.invoiceType === 'company' && this.companyVat ? this.companyVat : this.invoiceTaxcode,
					"postal_code": this.companyPostalCode,
					"state"      : this.companyProvince
				}
			}

			return data
		},
		submitPayment() {
			if (this.loadingPromoCode) return
			if (this.loadingPayment) return
			if (!this.fullname) {
				this.$alert(this.$t('alert.missing_name_surname'), null, 'warning');
				return
			}
			if (this.invoiceData && !this.checkInvoiceData()) {
				return
			}

			try {
				if (this.subscriptionPayment && this.subscriptionPayment.setup) {
					this.submitSetup()
					return
				}

				this.loadingPromoCode = false
				this.errorPage = false
				this.loadingPayment = true
				this.Stripe.confirmCardPayment(this.stripeData.secret, {
					'payment_method': {
						'card'           : this.cardElement,
						'billing_details': this.getBillingDetails()
					},
					'setup_future_usage': 'off_session'
				})
					.then((result) => {
						if (result.error) {
							console.error(result.error.message)
							if (result.error.type === 'card_error' || result.error.type === 'validation_error' || result.error.type === 'invalid_request_error') {
								this.$alert(this.$t('alert.invalid_card'), null, 'warning');
							} else {
								console.error(result.error)
								this.errorPage = true
							}
							this.loadingPromoCode = false
							this.loadingPayment = false
						} else {
							// Successful subscription payment
							this.paymentSuccess(result.paymentIntent)
						}
					})
			} catch(err) {
				if (err.message.indexOf('SetupIntent client secret') > 0) {
					console.warn(err.message)
					this.submitSetup()
					return
				}

				console.error(err.message)
				this.loadingPromoCode = false
				this.loadingPayment = false
				this.errorPage = true
			}
		},
		submitSetup() {
			this.loadingPromoCode = false
			this.errorPage = false
			this.loadingPayment = true
			this.Stripe.confirmCardSetup(this.stripeData.secret, {
				'payment_method': {
					'card'           : this.cardElement,
					'billing_details': this.getBillingDetails()
				}
			})
				.then((result) => {
					if (result.error) {
						console.error(result.error.message)
						if (result.error.type === 'card_error' || result.error.type === 'validation_error' || result.error.type === 'invalid_request_error') {
							this.$alert(this.$t('alert.invalid_card'), null, 'warning');
						} else {
							console.error(result.error)
							this.errorPage = true
						}
						this.loadingPromoCode = false
						this.loadingPayment = false
					} else {
						// The setup has succeeded. Display a success message.
						this.paymentSuccess(result.setupIntent)
					}
				})
		},
		paymentSuccess(intent) {
			let invoiceData = {}
			if (this.invoiceData) {
				invoiceData = {
					'type'       : this.invoiceType,
					'company'    : this.companyName,
					'name'       : this.invoiceName,
					'surname'    : this.invoiceSurname,
					'address'    : this.companyAddress,
					'postal_code': this.companyPostalCode,
					'city'       : this.companyCity,
					'province'   : this.companyProvince,
					'tax_code'   : this.invoiceTaxcode,
					'vat'        : this.companyVat,
					'pec'        : this.companyPec,
					'code'       : this.companyDestCode
				}
			}

			this.loadingPromoCode = true
			this.$store.dispatch('user/subscriptionSubmitted', {
				'token'  : this.accessToken,
				'stripe' : this.stripeData,
				'intent' : intent,
				'invoice': invoiceData
			})
				.then(res => {
					this.emptyPage = false
					this.errorPage = false

					return this.$alert(this.$t('alert.subscription_active'), null, 'success')
				})
				.then(res => {
					this.loadUserState()
				})
				.catch(err => {
					this.loadingPromoCode = false
					this.loadingPayment = false
					if (err.response && err.response.status) {
						switch (err.response.status) {
							case 404:
								this.emptyPage = true
								break
							case 500:
								this.errorPage = true
								break
							default:
								console.warn(err.response.status)
						}
					}
				})
		},
		getDate(timestamp) {
			if (timestamp === null || timestamp === undefined) return ''
			const d = new Date(timestamp * 1000)
			const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
			const month = months[d.getMonth()]

			return d.getDate() + ' ' + this.$t('time.month.' + month) + ' ' + d.getFullYear()
		},
		loadPromoCode() {
			this.loadingPromoCode = true
		},
		loadedPromoCode() {
			this.loadingPromoCode = false
			this.loadingPayment = false
		}
	},
	watch: {
		userState(newValue, oldValue) {
			if (newValue && oldValue && (oldValue.expired_subscription || oldValue.subscription_canceled || !oldValue.voucher_active)) {
				this.loadingPromoCode = false
				this.$nextTick(() => {
					this.prepareNewLoadUser()
				})
			} else if (newValue && newValue.voucher_active && !newValue.expired_subscription && !newValue.subscription_canceled) {
				this.loadingPromoCode = false
				this.$nextTick(() => {
					this.prepareNewLoadUser()
				})
			}
		}
	}
}
</script>
